import {ReactNode, ReactElement, ComponentType} from 'react';

export type ColumnType<TDataType extends DataType = DataType> = {
  id: string;
  Header: ReactElement | ReactNode | string | ComponentType;
  Cell?: ({row, column, index}: CellType<TDataType>) => ReactNode | ReactElement | string;
  width?: number | string;
  align?: 'left' | 'right' | 'center';
  className?: string;
};

export type CellType<TDataType extends DataType = DataType> = {
  row: TDataType;
  column: ColumnType<TDataType>;
  index: number;
};

export type DataType = {
  [key: string]: unknown;
};

export type SimpleTableRowType<TDataType extends DataType = DataType> = {
  sectionName?: ReactElement | ReactNode | string;
  data: TDataType[];
};

export type ExpandType<TDataType extends DataType = DataType> = {
  row: TDataType;
  index: number;
};

export type RowPropsType = {
  className?: string;
};
